var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRemoveLoyaltyInfo = function SvgRemoveLoyaltyInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 6.39242C14.2249 4.35958 16.4537 3 19 3C22.8442 3 25.9647 6.09879 25.9997 9.93473C25.0492 9.65189 24.0424 9.5 23 9.5C17.201 9.5 12.5 14.201 12.5 20C12.5 22.0527 13.0891 23.9679 14.1073 25.5856C13.7094 25.9093 13.3376 26.2145 13 26.5C12.4861 26.0655 11.8931 25.5853 11.2493 25.0639C6.82411 21.4802 0 15.9539 0 10C0 6.13401 3.13401 3 7 3C9.54633 3 11.7751 4.35958 13 6.39242Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 20C32 24.9705 27.9706 29 23 29C18.0294 29 14 24.9705 14 20C14 15.0294 18.0294 11 23 11C27.9706 11 32 15.0294 32 20ZM28 21C28.5523 21 29 20.5523 29 20C29 19.4477 28.5523 19 28 19H18C17.4477 19 17 19.4477 17 20C17 20.5523 17.4477 21 18 21H28Z",
    fill: "currentColor"
  })));
};
export default SvgRemoveLoyaltyInfo;